/**
 * Formázza a dátumot datetime-local input mezőhöz
 * @param date - A formázandó dátum
 * @returns YYYY-MM-DDTHH:MM formátumú string
 */
export const formatDateTimeForInput = (date: Date): string => {
  // Ellenőrizzük, hogy a dátum érvényes-e
  if (!date || isNaN(date.getTime())) {
    return ''; // Üres string, hogy a felhasználó saját dátumot írhassa be
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

/**
 * Formázza a dátumot megjelenítéshez
 * @param date - A formázandó dátum
 * @returns YYYY.MM.DD. HH:MM formátumú string
 */
export const formatDateTime = (date: Date | any): string => {
  // Ellenőrizzük, hogy a dátum érvényes-e
  if (!date) {
    return '-';
  }
  
  // Firestore Timestamp kezelése
  if (typeof date === 'object' && 'toDate' in date) {
    date = date.toDate();
  }
  
  // Ha nem Date objektum, próbáljuk konvertálni
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  
  // Ellenőrizzük, hogy érvényes dátum-e
  if (isNaN(date.getTime())) {
    return '-';
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}.${month}.${day}. ${hours}:${minutes}`;
};

/**
 * Formázza a dátumot rövid formátumban
 * @param date - A formázandó dátum
 * @returns YYYY.MM.DD formátumú string
 */
export const formatDate = (date: Date | any): string => {
  // Ellenőrizzük, hogy a dátum érvényes-e
  if (!date) {
    return '-';
  }
  
  // Firestore Timestamp kezelése
  if (typeof date === 'object' && 'toDate' in date) {
    date = date.toDate();
  }
  
  // Ha nem Date objektum, próbáljuk konvertálni
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  
  // Ellenőrizzük, hogy érvényes dátum-e
  if (isNaN(date.getTime())) {
    return '-';
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}.${month}.${day}`;
};

/**
 * Ellenőrzi, hogy a dátum lejárt-e
 * @param date - Az ellenőrizendő dátum
 * @returns true ha lejárt, false ha nem
 */
export const isOverdue = (date: Date | any): boolean => {
  if (!date) {
    return false;
  }
  
  // Firestore Timestamp kezelése
  if (typeof date === 'object' && 'toDate' in date) {
    date = date.toDate();
  }
  
  // Ha nem Date objektum, próbáljuk konvertálni
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  
  // Ellenőrizzük, hogy érvényes dátum-e
  if (isNaN(date.getTime())) {
    return false;
  }
  
  return date < new Date();
};

/**
 * Kiszámítja a napok számát két dátum között
 * @param startDate - Kezdő dátum
 * @param endDate - Befejező dátum
 * @returns Napok száma
 */
export const daysBetween = (startDate: Date, endDate: Date): number => {
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.round((endDate.getTime() - startDate.getTime()) / oneDay);
}; 